import {AffiliatesBannerSliceDefaultPrimaryAffiliateBlockItem} from 'prismicio-types'
import {AffiliateBlock} from './AffiliateBlock'

export const AffiliateSection = ({blocks}: {blocks: AffiliatesBannerSliceDefaultPrimaryAffiliateBlockItem[]}) => {
  return blocks.map((block, index) => {
    const colStart = index * 2 + 2
    return <AffiliateBlock colStart={colStart} key={`block-${index}`} block={block} />
  })
}
